var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRequestedhours(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 33.676,
    height: 33.818,
    viewBox: "0 0 33.676 33.818",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33.676,
    height: 33.818,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "requested_hours",
    "data-name": "requested hours",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_14587",
    "data-name": "Rectangle 14587",
    transform: "translate(3.934 4.281)",
    fill: "none",
    stroke: "#c4151c",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9.573,
    height: 9.822,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 8.573,
    height: 8.822,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_14592",
    "data-name": "Rectangle 14592",
    transform: "translate(3.934 15.87)",
    fill: "none",
    stroke: "#c4151c",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9.573,
    height: 9.822,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 8.573,
    height: 8.822,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_14588",
    "data-name": "Rectangle 14588",
    transform: "translate(16.598 4.281)",
    fill: "none",
    stroke: "#c4151c",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9.573,
    height: 9.822,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 8.573,
    height: 8.822,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_9142",
    "data-name": "Ellipse 9142",
    transform: "translate(15.263 15.405)",
    fill: "none",
    stroke: "#c4151c",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.207,
    cy: 9.207,
    rx: 9.207,
    ry: 9.207,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.207,
    cy: 9.207,
    rx: 8.707,
    ry: 8.707,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_4307",
    "data-name": "Path 4307",
    d: "M9.473.127A.547.547,0,0,0,8.7.2L4.208,4.158.934,2.415a.547.547,0,0,0-.774.774l3.7,2.166a.547.547,0,0,0,.387.16h.025a.548.548,0,0,0,.4-.2L9.544.9A.547.547,0,0,0,9.473.127Z",
    transform: "translate(18.562 25.035) rotate(-48)",
    fill: "#c4151c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4309",
    "data-name": "Path 4309",
    d: "M2187.108,3486.266H2172.37v-29.027h29.614v13.949h.556",
    transform: "translate(-2171.87 -3456.738)",
    fill: "none",
    stroke: "#c4151c",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequestedhours);
export default __webpack_public_path__ + "static/media/requested hours.8d508b2315526a81239a39a1edc121f7.svg";
export { ForwardRef as ReactComponent };